import { createFeatureSelector, createSelector } from '@ngrx/store';
import { SORTING_FEATURE_KEY } from '../keys';
import { SortingState } from '../reducers/sorting.reducer';

const selectState = createFeatureSelector<SortingState>(SORTING_FEATURE_KEY);

export const selectProduct = createSelector(selectState, (state: SortingState) => state.product);
export const selectSuggestions = createSelector(selectState, (state: SortingState) => state.suggestions);
export const selectContents = createSelector(selectState, (state: SortingState) => state.contents);
export const selectScanning = createSelector(selectState, (state: SortingState) => state.scanning);
export const selectSaving = createSelector(selectState, (state: SortingState) => state.saving);
